import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CRANIAL_PHOTO_VIEWS } from './cranialPhotoViews';

/**
 * Select da vista da foto (opcional). Usado no popup de medidas e no popup
 * genérico de upload, via renderItemFields.
 */
const CranialPhotoViewSelect = ({ value, onChange, disabled = false, minWidth = 180 }) => {
    return (
        <FormControl size="small" sx={{ minWidth: `${minWidth}px` }} disabled={disabled}>
            <InputLabel>Vista</InputLabel>
            <Select
                label="Vista"
                value={value || ''}
                onChange={(event) => onChange(event.target.value)}
            >
                <MenuItem value="">Sem vista</MenuItem>

                {CRANIAL_PHOTO_VIEWS.map((item) => (
                    <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CranialPhotoViewSelect;
